import { useContext, useEffect, useState } from "react";
import Input from "../../material/input/Input";
import Breadcrumb from "../breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../headBar/HeadBar";
import * as publicApi from "../../../service/publicApi";
import * as regex from "../../../service/regex";
import Button from "../../material/button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../../App";
import { RedirectCode400 } from "../../RedirectCode400";

export default function ConfirmTel() {
  const nav = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);
  const location = useLocation();
  const data = location.state;
  const [tel, setTel] = useState("");

  useEffect(() => {
    if (!data) {
      nav(RedirectCode400());
    }
  }, [data]);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ลืมรหัสผ่าน", url: "/forgotPassword" },
    { name: "ยืนยันหมายเลขโทรศัพท์", url: "/forgotPassword/confirmTel" },
  ];

  const handleInputChange = (e) => {
    setTel(e);
  };

  const onClickSubmit = async () => {
    const res = await publicApi.requestOtp({
      phone_number: tel,
      token: data["token"],
    });
    if (res) {
      if (res["data"]["code"] === 200) {
        sessionStorage.removeItem("hasVisitedPage");
        nav("/forgotPassword/otpRequest", {
          state: {
            phone_number: tel,
            otp: {
              token: res["data"]["data"]["token"],
              ref_code: res["data"]["data"]["ref_code"],
              otp_count: res["data"]["data"]["otp_count"],
            },
          },
        });
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };
  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <div className="flex flex-col items-center gap-5 w-full mt-[100px] min-h-[50vh]">
          <div className="w-full text-center text-2xl font-bold">
            กรุณายืนยันหมายเลขโทรศัพท์
          </div>
          <div className="w-full text-center text-base font-bold">
            ยืนยันหมายเลขโทรศัพท์ เพื่อรับ OTP
          </div>
          <div className="w-full text-center text-2xl font-bold">
            {data?.phone_number}
          </div>
          <div className="sm:w-full flex flex-col w-[60%]">
            <Input
              regex={regex.phoneNumber()}
              label={"เบอร์โทรศัพท์"}
              placeholder="พิมพ์หมายเลขโทรศัพท์ติดกันโดยไม่มีขีด"
              value={tel}
              setValue={handleInputChange}
            ></Input>
          </div>
          <div className="flex flex-col gap-5 w-[60%] min-w-[267px]">
            <Button onClick={onClickSubmit}>ขอตั้งรหัสผ่านใหม่</Button>
          </div>
        </div>
      </div>
    </>
  );
}
